<div class="row">
  <div class="col s12">
    <div class="card">
      <div class="card-content">

        <div class="row teams-container" *ngIf="groupList && groupList.length > 0">
          <div class="col s6">
            <h4 class="text-wrap" *ngIf="_teamMembers" [innerHTML]="_teamMembers.title.rendered">
            </h4>
          </div>
          <div class="col s6 dropdown-contain flex justify-end">
            <mat-form-field appearance="outline" floatLabel="never" subscriptSizing="dynamic" class="dropdown">
              <mat-select value="Manager" [formControl]="roleFormControl" (selectionChange)="teamRoleSelect($event.value)">
                <mat-option value="All">
                  All
                </mat-option>
                <mat-option value="Manager">
                  Manager
                </mat-option>
                <mat-option value="Team Leader">
                  Team Leads
                </mat-option>
                <mat-option value="Developer">
                  Team Members
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row" style="overflow-x: scroll" style="margin-bottom: 7px !important;">
          <div class="col s12" style="overflow-x: scroll">
            <app-users-table [developerList]="_teamMemberListOnMode" [modalRef]="userModal" [isHideTeams]="true"
              (modalOpen)="openUserModal($event)" (sortingData)="sortData($event)" [isMaxContent]="'width:auto'"
              [widthStyle]="true" [showAction]="false" [loadWaiter]="loading" [isTeam]="true"
              [activeSort]="activeSort"></app-users-table>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div #userModal class="modal">
  <app-create-user [isEditable]="{id: editUserId, isEdit: isUserEditable}"></app-create-user>
</div>